import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import URL from "../../../../constant/URL";
import Guide1 from "./Guide1";
import Guide2 from "./Guide2";
import Notice from "./Notice";
import EnterLearnerData from "./EnterLearnerData";
import AiPrediction from "./AiPrediction";
import AnsweringAIDiagnosisInitializer from "../../../answeringQuestions/aiDiagnosisTest/container/AnsweringAIDiagnosisInitializer";
import AnsweringAIDiagnosis from "../../../answeringQuestions/aiDiagnosisTest/presentational/AnsweringAIDiagnosis";
import Analysis from "./Analysis";
// import Result from "./Result";
import ResultV2 from './ResultV2';
import EntryCheck from "../../../provider/EntryCheck";
import AiPredictionGB from "../../../global/aiDiagnosisTest/AiPredictionGB";
import DiagnosisGuide1 from "./DiagnosisGuide1";
import DiagnosisGuide2 from "./DiagnosisGuide2";
import DiagnosisGuide3 from "./DiagnosisGuide3";

const AiDiagnosisTest = () => {

  const routeMatch = useRouteMatch();

  return <Route path={ `${ routeMatch.url }/:depth4` }><Children /></Route>;

};

const Children = () => {

  return (
    <Switch>
      <Route path={ URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.DIAGNOSIS_GUIDE1 }><DiagnosisGuide1 /></Route>
      <Route path={ URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.DIAGNOSIS_GUIDE2 }><DiagnosisGuide2 /></Route>
      <Route path={ URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.DIAGNOSIS_GUIDE3 }><DiagnosisGuide3 /></Route>
      <Route path={ URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.GUIDE1 }><Guide1 /></Route>
      <Route path={ URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.GUIDE2 }><Guide2 /></Route>
      <Route path={ URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.NOTICE }><Notice /></Route>
      <Route path={ URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.ENTER_LEARNER_DATA }><EnterLearnerData /></Route>
      <Route path={ URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.AI_PREDICTION }>
        <EntryCheck 
          GM={<AiPrediction />}
          CP={<AiPrediction />}
          GM_APP={<AiPrediction />}
          WJTB={<AiPrediction />}
          GLOBAL01={<AiPredictionGB />}
        />
      </Route>
      <Route path={ URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.ANSWERING_QUESTIONS }><AnsweringAIDiagnosisInitializer><AnsweringAIDiagnosis /></AnsweringAIDiagnosisInitializer></Route>
      <Route path={ URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.ANALYSIS }><Analysis /></Route>
      {/* <Route path={ URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.RESULT }><Result /></Route> */}
      <Route path={ URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.RESULT }><ResultV2 /></Route>
    </Switch>
  );
};

export default AiDiagnosisTest;
